import { PersonalDetailsFormNewModel } from './formModel';

export const personalDetailsInitialValues: PersonalDetailsFormNewModel = {
  title: undefined,
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  eirCode: '',
  town: '',
  county: '',
};
